import { addWeeks, isMonday, set, startOfWeek, subWeeks } from 'date-fns'

export function getSellerFlashSalePeriod(now: Date) {
  const mondayThisWeek = set(startOfWeek(now, { weekStartsOn: 1 }), {
    hours: 12,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  })
  // If it's Monday before 12pm, the current week hasn't started yet
  const startDate =
    isMonday(now) && now.getHours() < 12
      ? subWeeks(mondayThisWeek, 1)
      : mondayThisWeek

  return { startDate, endDate: addWeeks(startDate, 1) }
}
